// Το API κρατήσεων από το ταμείο: ίδια διαδρομή, ίδιοι κανόνες και κλειδώματα με τη Sala
// (xentrix_flow backend routes/reservations.js). Ο server ελέγχει ώρες, τραπέζια, δικαιώματα.

import { API_BASE_URL } from '../../config/api';
import type { Availability, Day, Guest, NewReservation, Reservation, ResAction } from './types';

export class ResError extends Error {
  status: number;
  body: Record<string, unknown>;
  constructor(status: number, body: Record<string, unknown>) {
    super(String(body.error || `HTTP ${status}`));
    this.status = status;
    this.body = body;
  }
}

async function call<T>(path: string, init: { method?: string; body?: unknown } = {}): Promise<T> {
  const res = await fetch(`${API_BASE_URL}/api/reservations${path}`, {
    method: init.method || 'GET',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('xentrix_token')}`,
      ...(init.body !== undefined ? { 'Content-Type': 'application/json' } : {}),
    },
    body: init.body !== undefined ? JSON.stringify(init.body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new ResError(res.status, data as Record<string, unknown>);
  return data as T;
}

export const resApi = {
  day: (storeId: number, date: string) => call<Day>(`/${storeId}/day?date=${date}`),
  availability: (storeId: number, date: string, party: number, excludeId?: number | null) =>
    call<Availability>(`/${storeId}/availability?date=${date}&party=${party}${excludeId ? `&exclude_id=${excludeId}` : ''}`),
  guests: (storeId: number, q: string) => call<Guest[]>(`/${storeId}/guests?q=${encodeURIComponent(q)}`),
  create: (storeId: number, body: NewReservation) => call<Reservation>(`/${storeId}/reservations`, { method: 'POST', body }),
  update: (storeId: number, id: number, body: Partial<NewReservation>) => call<Reservation>(`/${storeId}/reservations/${id}`, { method: 'PATCH', body }),
  act: (storeId: number, id: number, action: ResAction, body: { table_ids?: number[]; notify?: string; reason?: string; force?: boolean } = {}) =>
    call<{ reservation: Reservation }>(`/${storeId}/reservations/${id}/${action}`, { method: 'POST', body }),
};
